import { UserRedeemedCoupon } from "@interfaces/coupon/coupon"
import { RootState } from "@redux/store"
import { verifyUserCoupons } from "@services/coupon/coupon"
import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"

const useUserHasActiveCoupon = () => {
    const [ data, setData ] = useState<UserRedeemedCoupon[] | null>(null)
    const [ error, setError ] = useState<unknown | null>(null)
    const [ isLoading, setIsLoading ] = useState<boolean>(false)
    const [ hasLoaded, setHasLoaded ] = useState<boolean>(false)

    const { username } = useSelector((state: RootState) => state.session)

    const loadData = useCallback(async() => {
        setHasLoaded(false)
        try
        {
            if(!username) return
            const resp = await verifyUserCoupons({ username, status: "used" })
            setData(resp)
            setError(null)
        }
        catch(err)
        {
            console.error("verifyUserCoupons", err)
            setData(null)
            setError(err)
        }
        finally
        {
            setIsLoading(false)
            setHasLoaded(true)
        }
    }, [username])

    useEffect(() => {
        loadData()
    }, [loadData, username])

    return { data, error, isLoading, reloadData: loadData, hasLoaded }
}

export default useUserHasActiveCoupon
